class InterviewSlide {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var interviewSwiper = new Swiper(".otherInterviewSwiper", {
      // loop: true,
      slidesPerView: 1.3,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 40,
          initialSlide: 0,
          centeredSlides: false,
          loopAdditionalSlides: 0,
        }
      },
      navigation: {
        nextEl: ".js-interview-next",
        prevEl: ".js-interview-prev",
      },
      pagination: {
        el: ".interviewpagination",
        clickable: true
      }
    });
  }
}